// extracted by mini-css-extract-plugin
export default {"checkbox":"FormCheckbox_checkbox__fWFP5","checkbox-outline":"FormCheckbox_checkbox-outline__U0FTd","checkbox-checked":"FormCheckbox_checkbox-checked__atRLG"};